var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"header-instruments no-mobile"},[_c('badges'),_c('personal-area'),_c('user-info')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }